import officeApiCallAsync from './office-api-call-async'

export default async function officeApiGetAsync<T>(
  requirementSet: string,
  apiMethodName: any,
  apiMethodAsync: () => Promise<Office.AsyncResult<T>>,
  defaultValue?: T,
): Promise<T> {
  try {
    const asyncResult = await officeApiCallAsync<Office.AsyncResult<T>>(requirementSet, apiMethodName, apiMethodAsync)

    if (asyncResult.status === Office.AsyncResultStatus.Succeeded) {
      return asyncResult.value
    } else {
      throw asyncResult.error
    }
  } catch (error) {
    if (defaultValue !== undefined) {
      return defaultValue
    } else {
      throw error
    }
  }
}
